<template>
    <div class="min-h-screen bg-background font-sans selection:bg-primary/10">
        <main class="pt-32 pb-20 container mx-auto px-4">
            <!-- <div class="max-w-4xl mx-auto"> -->
            <div class="max-w-5xl mx-auto">
                <transition name="fade-up" appear>
                    <div class="text-center mb-16">
                        <h1 class="text-5xl font-serif mb-4">Exhibition Moments</h1>
                        <p class="max-w-2xl mx-auto text-gray-600 text-sm leading-relaxed">
                            A behind-the-scenes look at Art Pulse by Shruti at exhibitions and community events — booth
                            setups, gallery walls, and the joy of meeting art lovers.
                        </p>
                        <div
                            class="mt-4 flex justify-center items-center gap-4 text-xs text-gray-500 uppercase tracking-widest">
                            <span class="flex items-center gap-1">
                                <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                                    <path
                                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z" />
                                </svg>
                                USA • Pop-ups & community events
                            </span>
                            <a href="https://www.instagram.com/artpulse_by_shruti/" class="underline hover:text-black">Follow on Instagram ↗</a>
                        </div>
                    </div>
                </transition>
            </div>


            <main class="grid grid-cols-1 lg:grid-cols-3 gap-8">

                <div class="lg:col-span-2 grid grid-cols-2 md:grid-cols-3 gap-3">

                    <div class="relative aspect-square bg-gray-100 overflow-hidden" v-for="(item, index) in galleryItems" :key="index">
                        <img :src="item.small_fullurl" class="object-cover w-full h-full"  alt="Display">
                        <!-- <span
                            class="absolute top-2 left-2 bg-white/90 text-[10px] px-2 py-1 font-bold uppercase tracking-tighter">Exhibition
                            Display</span> -->
                    </div>

                    
                </div>

                <aside v-if="testimonials.length" class="border border-gray-100 bg-white p-6 shadow-sm">
                    <div class="flex justify-between items-center mb-8">
                        <h2 class="text-2xl font-serif">Testimonials</h2>
                        <span
                            class="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1">
                            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
                                <path
                                    d="M14.017 21L14.017 18C14.017 16.8954 13.1216 16 12.017 16H9.01703V14H12.017C14.2262 14 16.017 15.7909 16.017 18V21H14.017ZM10.017 21L10.017 18C10.017 16.8954 9.1216 16 8.01703 16H5.01703V14H8.01703C10.2262 14 12.017 15.7909 12.017 18V21H10.017Z" />
                            </svg>
                            Community
                        </span>
                    </div>

                    <div class="space-y-6">
                        <div v-for="testimonial in testimonials" :key="testimonial.id || testimonial.email || testimonial.name" class="border-b border-gray-100 pb-6">
                            <div class="flex gap-4 mb-3">
                                <div
                                    class="w-10 h-10 bg-gray-100 flex-shrink-0 flex items-center justify-center text-gray-400">
                                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                        <path
                                            d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.314 0-8 1.686-8 5v1c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2v-1c0-3.314-4.686-5-8-5z" />
                                    </svg>
                                </div>
                                <p class="text-xs text-gray-600 italic">"{{ testimonial.message }}"
                                </p>
                            </div>
                            <div class="flex justify-between items-end pl-14">
                                <div>
                                    <p class="text-sm font-bold">{{ testimonial.name }}</p>
                                    <div class="flex text-yellow-400 text-xs" aria-label="Rating">
                                        <span v-for="star in Number(testimonial.rating || 5)" :key="star">★</span>
                                    </div>
                                </div>
                                <span class="text-gray-200 text-xl font-serif">“</span>
                            </div>
                        </div>
                    </div>

                    <button type="button" @click="scrollToTop"
                        class="w-full mt-8 py-3 border border-black text-[10px] font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors">
                        Back to top
                    </button>
                </aside>
            </main>

            <!-- <footer class="mt-12 bg-gray-50 p-6 text-center text-gray-400 text-xs">
                <p>You can replace any of these photos later with your real exhibition images. This page is built to
                    scale —
                    just drop in new images and the layout stays polished.</p>
            </footer> -->
        </main>
    </div>
</template>

<script>
import api from '@/services/api';
import ConstantPage from '@/components/utilities/ConstantPage.vue';
import { useTestimonialStore } from '@/store/testimonialStore';

export default {
    name: 'AboutUs',
    mixins: [ConstantPage],
    data() {
        return {
            artistImage: 'https://assets-allwebsites.s3.ap-south-1.amazonaws.com/artpulse/shruti.jpeg',
            works: [],
            galleryItems: []
        }
    },
    mounted() {
        // this.fetchWorks();
        this.fetchGalleryItems();
        this.fetchTestimonials();
    },
    computed: {
        testimonials() {
            return useTestimonialStore().testimonials.slice(0, 4);
        }
    },
    methods: {
        async fetchGalleryItems() {
            try {
                let param = {
                    companyid: this.COMPANY_ID,
                    category_name: 'exhibition'
                }
                const response = await api.post('api/gallery/list', param);
                if (response.data?.data.length == 0) {
                    return;
                }
                this.galleryItems = response.data?.data[0].gallery_media || [];
            } catch (error) {
                console.error('Failed to fetch gallery items:', error);
            }
        },
        fetchTestimonials() {
            useTestimonialStore().fetchTestimonials({
                companyid: this.COMPANY_ID
            });
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // async fetchWorks() {
        //     try {
        //         // Fetching a few products to display as "Selected Works"
        //         let param = {
        //             limit: 6, // Fetching 6 items for a balanced grid
        //             fetchColumns: 'id,name,productmedia,product_category'
        //         }
        //         const response = await api.post('api/product/getwithcategories', param);
        //         const products = response.data?.data || [];

        //         this.works = products.map(product => ({
        //             id: product.id,
        //             title: product.name,
        //             image: product.productmedia?.[0]?.small_fullurl || '',
        //             category: product.product_category?.[1]?.name ?? 'Artwork'
        //         })).filter(w => w.image);

        //     } catch (error) {
        //         console.error('Failed to fetch works:', error);
        //     }
        // }
    }
}
</script>

<style scoped>
.fade-up-enter-active,
.fade-up-leave-active {
    transition: opacity 1s ease, transform 1s ease;
}

.fade-up-enter-from,
.fade-up-leave-to {
    opacity: 0;
    transform: translateY(40px);
}
</style>
